import React from "react";
import { useTranslation } from "react-i18next";
import { Disclosure } from "@outpave/ds";

export interface AppFooterProps {
  /** Pre-translated by the caller, e.g. `t("PlatformFooterText")` or the platform's own disclosure. */
  disclosure?: string;
  bg?: string;
  /** False lets the footer sit in normal flow at the end of the content. */
  sticky?: boolean;
}

const AppFooter: React.FC<AppFooterProps> = ({
  disclosure,
  bg = "var(--color-bg-surface)",
  sticky = true,
}) => {
  const { t } = useTranslation();

  return (
    <Disclosure
      text={disclosure ?? ""}
      linkLabel={t("BrandFetchFooter")}
      linkHref="https://brandfetch.com/developers/logo-api"
      sx={{
        ...(sticky ? { position: "sticky", bottom: 0 } : {}),
        backgroundColor: bg,
        minHeight: 44,
      }}
    />
  );
};

export default AppFooter;
